import { Amount } from '../types/amount';
import { formatPrice as originalFormatPrice } from './price';
export {
  addThousandSeparators,
  amountPropertiesToUnit,
  amountToUnit,
  unitToAmount,
  comparePrices,
  getConvertedPrice,
  getCurrencySymbol,
  subtractPrices,
  sumPrices,
  toMinorUnitProperties,
  toUnit,
  absolutePrice,
  getMaxAmount,
  getMinAmount,
  getCurrencyPriceConversion,
} from './price';
import i18n from '@monolith/legacy/services/i18n';

/**
 * @deprecated, use `formatPrice` from `@monolith/core/utilities/price` instead and pass the locale as a parameter.
 * Alternatively, use the `usePrice` composable which will inject the correct locale automatically.
 * Please do not import '@monolith/legacy/services/i18n' directly to access the locale.
 */
export const formatPrice = (price: Amount, format = undefined, locale = i18n.global.locale) => {
  return originalFormatPrice(price, format, locale);
};
